import axios from "axios";
import {config} from "../config";
import GeneralService from "./GeneralService";
import {store} from "../store";
import {IPlayedCard} from "../models/game/IPlayedCard";
import ServerStateDispatcher from "../services/states/ServerStateDispatcher";
import {WsService} from "../services/PvP/WsService";
import RequestHelper from "../services/RequestHelper";

export default class GameService {

    static async confirmStartGame(players){
        if(!WsService.inQueue){
            return;
        }

        const data = {
          'players':players
        }
        return axios.post(config.serverUrl + '/api/game/pvp/confirm-start-game',data, GeneralService.makeHeader())
    }

    static async queue(){
        if(!WsService.inQueue){
            return;
        }
        const data = {
            'version': config.VERSION
        }

        return axios.post(config.serverUrl + '/api/game/pvp/queue',data, GeneralService.makeHeader())
    }

    static  cancelQueue(){
     axios.post(config.serverUrl + '/api/game/pvp/cancel-queue',{}, GeneralService.makeHeader())
    }

    // CPU
    static async startGame(cpuId:number){

        ServerStateDispatcher.startStackLoop();

        return axios.post(config.serverUrl + '/api/game/cpu/start',{cpu_id:cpuId}, GeneralService.makeHeader())
    }



    static async playCard(playedCard: IPlayedCard) {
        const state = store.getState();

        const data: any = {
            hand_key: playedCard.handKey,
            game_id: state.game.game.game_id
        };

        if (playedCard.target !== null) {
            data[playedCard.target.key] = playedCard.target.value;
            data['side'] = playedCard.target.side;
        }

        let urlPath = '/api/game/cpu/play-card';
        if (state.game.isPvP === true) {
            urlPath = '/api/game/pvp/play-card';
        }

        return RequestHelper.postWithDelayedLoading(
            config.serverUrl + urlPath,
            data,
            GeneralService.makeHeader(),
            2000
        );
    }

    static async endTurn(handKey: string | null, skipTurn = false) {
        const state = store.getState();

        const data: any = {
            player_attack: state.game.playerAD,
            game_id: state.game.game.game_id,
            skip_turn: skipTurn
        };

        if (handKey !== null) {
            data['discard_card'] = handKey;
        }

        let urlPath = '/api/game/cpu/end-turn';
        if (state.game.isPvP === true) {
            urlPath = '/api/game/pvp/end-turn';
        }

        return RequestHelper.postWithDelayedLoading(
            config.serverUrl + urlPath,
            data,
            GeneralService.makeHeader(),
            3000
        );
    }

    static async makeMulligan(){

        let state = store.getState();
        let data = {
            game_id: state.game.game.game_id
        };

        let path = '/api/game/cpu/mulligan';

        if(state.game.isPvP){
            path = '/api/game/pvp/mulligan';
        }

        return axios.post(config.serverUrl + path, data, GeneralService.makeHeader())
    }

    static async giveUp(){

        let state = store.getState();
        let data = {
            game_id: state.game.game.game_id
        };

        let path = '/api/game/cpu/giveup';

        if(state.game.isPvP){
            path = '/api/game/pvp/giveup';
        }

        return axios.post(config.serverUrl + path, data, GeneralService.makeHeader())
    }

    static async sendWarning(){

        let state = store.getState();
        let data = {
            game_id: state.game.game.game_id
        };

        let path = '/api/game/pvp/warning';

        return axios.post(config.serverUrl + path, data, GeneralService.makeHeader())
    }
    static  cancelWarning(){
        axios.post(config.serverUrl + '/api/game/pvp/cancel-warning',{}, GeneralService.makeHeader())
    }

}
